import { gql } from '@apollo/client'

export const qmrHolesQuery = gql`
    query quoteModelRevisionWithHoles($id: UUID!, $showDeleted: Boolean) {
        quoteModelRevision(id: $id, showDeleted: $showDeleted) {
            id
            quoteModel {
                id
                quote {
                    id
                }
            }
            dfmReports {
                quoteAttachmentRevisionId
                asset {
                    id
                    createdAt
                    downloadUrl
                    fileName
                }
                isPublished
                uploaderEmail
                source
            }
            holes {
                id
                groupKey
                patches {
                    id
                }
                type
                depth
                diameter
                isBlind
                tipAngle
                counterboreDepth
                counterboreDiameter
                countersinkAngle
                countersinkDepth
                countersinkDiameter
                direction
                endPoint
                startPoint
                tapOptions {
                    id
                    maxDepth
                    commonName
                }
                tapAnnotation {
                    id
                    depth
                    tapOption {
                        id
                        maxDepth
                        commonName
                    }
                }
            }
        }
    }
`

export const getQmrAttachmentAnnotations = gql`
    query getQmrAttachmentAnnotations(
        $attachmentId: UUID!
        $quoteModelRevisionId: UUID
    ) {
        getQmrAttachmentAnnotations(
            attachmentId: $attachmentId
            quoteModelRevisionId: $quoteModelRevisionId
        ) {
            id
            annotationsDataDownloadUrl
            attachmentId
            createdAt
            createdBy {
                id
                displayName
            }
            updatedAt
            updatedBy {
                id
                displayName
            }
        }
    }
`

export const getInspectionPointCount = gql`
    query getInspectionPointCount($attachmentId: UUID!) {
        getInspectionPointCount(attachmentId: $attachmentId) {
            db
            s3
            autoInspectionPoint
        }
    }
`
